import {createAsyncThunk} from '@reduxjs/toolkit';

export const getMeetings = createAsyncThunk(
	"meetings/getMeetings",
	async function ({timeStampStart, timeStampEnd}, {rejectWithValue}) {
		try {
			const res = await fetch(`/api/admin/get-meetings?start=${timeStampStart}&end=${timeStampEnd}`)
			const data = await res.json();
			return data;
		} catch (error) {
			return rejectWithValue(error.message);
		}

	}
);
